import { call, put, select, takeLatest } from 'redux-saga/effects';

import API from 'services/api';

import { fetchProfile } from 'store/session/actions';
import { getGroupId } from 'store/session/selectors';

import { types, updateSupplierTaxRate } from './actions';

export default function* root() {
  yield takeLatest(
    types.UPDATE_SUPPLIER_TAX_RATE_REQUEST,
    watchUpdateSuppliersTaxRate,
  );
}

function* watchUpdateSuppliersTaxRate(action) {
  const { taxRate, cb } = action.payload;
  try {
    const groupId = yield select(getGroupId);
    yield call(API.groups.updateUserGroup, groupId, { taxRate });
    // reload the users profile to include updated tax rate
    yield put(fetchProfile.request());
    yield put(updateSupplierTaxRate.success());
    cb && cb();
  } catch (e) {
    yield put(updateSupplierTaxRate.error(e));
    cb && cb(e);
  }
}
